import React from 'react';
import { motion } from 'framer-motion';

const LogoRing = ({ partners }) => {
    // Double partners for a perfect infinite loop seam
    const duplicatedPartners = [...partners, ...partners];

    return (
        <div className="relative w-full overflow-hidden py-6 md:py-10">
            {/* Gradient masks for smooth fade edges */}
            <div className="absolute left-0 top-0 bottom-0 w-24 md:w-64 bg-gradient-to-r from-white via-white/80 to-transparent z-10 pointer-events-none" />
            <div className="absolute right-0 top-0 bottom-0 w-24 md:w-64 bg-gradient-to-l from-white via-white/80 to-transparent z-10 pointer-events-none" />

            <motion.div
                className="flex items-center gap-16 md:gap-32 w-max"
                style={{ willChange: "transform" }}
                animate={{
                    x: [0, "-50%"]
                }}
                transition={{
                    duration: 25,
                    repeat: Infinity,
                    ease: "linear",
                    repeatType: "loop"
                }}
            >
                {duplicatedPartners.map((partner, idx) => (
                    <div
                        key={`${partner.name}-${idx}`}
                        className="flex-shrink-0 flex flex-col items-center group"
                    >
                        <div className="relative">
                            <img
                                src={partner.logo}
                                alt={partner.name}
                                className="h-8 md:h-12 w-auto object-contain transition-all duration-500 opacity-40 group-hover:opacity-100 grayscale group-hover:grayscale-0 contrast-125"
                            />
                            {/* Subtle underglow on hover */}
                            <div className="absolute -inset-4 bg-primary/10 rounded-full blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500 -z-1" />
                        </div>
                        <span className="mt-4 text-[10px] md:text-xs font-black uppercase tracking-widest text-slate-400 group-hover:text-primary transition-colors opacity-0 group-hover:opacity-100 transform translate-y-2 group-hover:translate-y-0 duration-300">
                            {partner.name}
                        </span>
                    </div>
                ))}
            </motion.div>
        </div>
    );
};

export default LogoRing;
